import DateFormat from './DateFormat';

export default class TariffAnnouncementUtils {
    static isKockakezdetEqualOrGreater(year, modozat, store) {
        const locationInStore = () => {
            switch (modozat) {
            case 'kgfb':
                return 'ajanl_kock_kezd';
            case 'casco':
                return 'kock_kezd_casco';
            default:
                throw new Error('TariffAnnouncementUtils.isKockakezdetEqualOrGreater modozat is not implemented yet');
            }
        };
        const kockKezd = new Date(
            DateFormat.plainToDashed(
                store.getters.tarifaData[locationInStore()],
            ),
        );
        return kockKezd.getFullYear() >= year;
    }

    static isKockakezdetEqualJanuar1(modozat, store) {
        const locationInStore = () => {
            switch (modozat) {
                case 'kgfb':
                    return 'ajanl_kock_kezd';
                case 'casco':
                    return 'kock_kezd_casco';
                default:
                    throw new Error('TariffAnnouncementUtils.isKockakezdetEqual modozat is not implemented yet');
            }
        };
        const kockKezd = new Date(
            DateFormat.plainToDashed(
                store.getters.tarifaData[locationInStore()],
            ),
        );
        console.log(kockKezd, kockKezd.getDay(), kockKezd.getMonth());
        return kockKezd.getDay() === 1 && kockKezd.getMonth() === 0;
    }

    static isKockakezdetEqual(year, modozat, store) {
        const locationInStore = () => {
            switch (modozat) {
            case 'kgfb':
                return 'ajanl_kock_kezd';
            case 'casco':
                return 'kock_kezd_casco';
            default:
                throw new Error('TariffAnnouncementUtils.isKockakezdetEqual modozat is not implemented yet');
            }
        };
        const kockKezd = new Date(
            DateFormat.plainToDashed(
                store.getters.tarifaData[locationInStore()],
            ),
        );
        return kockKezd.getFullYear() === year;
    }

    static isKockakezdetLesser(year, modozat, store) {
        const locationInStore = () => {
            switch (modozat) {
            case 'kgfb':
                return 'ajanl_kock_kezd';
            case 'casco':
                return 'kock_kezd_casco';
            default:
                throw new Error('TariffAnnouncementUtils.isKockakezdetLesser modozat is not implemented yet');
            }
        };
        const kockKezd = new Date(
            DateFormat.plainToDashed(
                store.getters.tarifaData[locationInStore()],
            ),
        );
        return kockKezd.getFullYear() < year;
    }

    static isKockakezdetGreater(year, modozat, store) {
        const locationInStore = () => {
            switch (modozat) {
                case 'kgfb':
                    return 'ajanl_kock_kezd';
                case 'casco':
                    return 'kock_kezd_casco';
                default:
                    throw new Error('TariffAnnouncementUtils.isKockakezdetGreater modozat is not implemented yet');
            }
        };
        const kockKezd = new Date(
            DateFormat.plainToDashed(
                store.getters.tarifaData[locationInStore()],
            ),
        );
        return kockKezd.getFullYear() > year;
    }

    static isKockakezdetEqualOrGreaterMarch1(modozat, store) {
        const locationInStore = () => {
            switch (modozat) {
                case 'kgfb':
                    return 'ajanl_kock_kezd';
                case 'casco':
                    return 'kock_kezd_casco';
                default:
                    throw new Error('TariffAnnouncementUtils.isKockakezdetEqual modozat is not implemented yet');
            }
        };
        const kockKezd = new Date(
            DateFormat.plainToDashed(
                store.getters.tarifaData[locationInStore()],
            ),
        );
        return kockKezd.getDay() >= 0 && kockKezd.getMonth() === 2;
    }

    static isKockakezdetAfterOrEqualMonth(modozat, store, month) {
        const locationInStore = () => {
            switch (modozat) {
                case 'kgfb':
                    return 'ajanl_kock_kezd';
                case 'casco':
                    return 'kock_kezd_casco';
                default:
                    throw new Error('TariffAnnouncementUtils: modozat not implemented');
            }
        };

        const rawDate = store.getters.tarifaData[locationInStore()];

        const kockKezd = new Date(
            DateFormat.plainToDashed(rawDate)
        );

        const targetMonth = month - 1;

        const compareDate = new Date(
            kockKezd.getFullYear(),
            targetMonth,
            1
        );

        return kockKezd >= compareDate;
    }
}
